export const TAAPI_API_KEY = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbHVlIjoiNjU5Njk2NDExNDBjZmQ3MjNkMTQwMTA4IiwiaWF0IjoxNzA0NDc1NDcxLCJleHAiOjMzMjA4OTM5NDcxfQ.66p9NRBiCr9sIO3gsqSFHxa8Y4xO9krcOoBihSdFUZM`

export const VINTAGE_API= "LA0FOFP4LWAI2XK6"
// export const VINTAGE_API= "BFIVE9PGZQKI0A98"